<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expense Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Expense Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expense Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_field",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "mode_field",
          sortable: true,
          label: "MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE/TIME",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_field",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "mode_field",
          sortable: true,
          label: "MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE/TIME",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        category: "",
      },
      totals: {
        totalAmount: 0,
        totalBalance: 0,
      },
      filterTitle: "",
      filteredReport: [],
      json_fields: {
        CATEGORY: "category",
        TOTAL_AMOUNT: "amount",
        MODE_TYPE: "mode.type_name",
        MODE_NAME: "mode.name",
        ACCOUNT_NUMBER: "mode.account_number",
        DESCRIPTION: "description",
        MADE_BY: "user",
        DATE: "date",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters("expenses", ["Expenses", "ExpenseCategories","filterStatus"]),
    ...mapState("expenses", ["expenses"]),
    ...mapGetters("auth", ["business","branch","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Expenses ? this.Expenses.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  watch: {
    expenses(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Expenses ? this.Expenses.length : 1;
  },
  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchExpensesReport",
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    filterReport(){
      this.FetchExpenses(this.data);
    }
  },

  updated(){
    let total_amount = 0;
    // let total_paid = 0;
    if(this.Expenses){
      this.Expenses.forEach((item)=>{
        total_amount = total_amount+parseInt(item.amount);
      });
      this.totals.totalAmount = total_amount;            
    }
  },

  created() {
    this.FetchExpenses(this.data);
    this.FetchExpenseCategories();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-3">
                <download-excel
                  class="btn btn-info mt-4"
                  :data="Expenses"
                  :fields="json_fields"
                  :worksheet="'EXPENSES REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Expenses_report from ' +data.datefrom+' to '+data.dateto+'.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>Expense Category</label>
                  <model-list-select
                    :list="ExpenseCategories ? ExpenseCategories : []"
                    v-model="data.category"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Category"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Expenses ? Expenses : []"
                :fields="branchid==0?fields1:fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(balance_field)="data">
                  {{ thousandSeprator(data.item.balance) }}
                </template>
                <template #cell(amount_field)="data">
                  {{ thousandSeprator(data.item.amount) }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode.name }} ({{ data.item.mode.type_name }}-{{ data.item.mode.account_number }})
                </template>            
              </b-table>
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>Total Expenses: <span class="text-danger">{{(totals.totalAmount>0?totals.totalAmount.toLocaleString():0)}}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!Expenses"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
